'use es6';

import { fromJS } from 'immutable';
import * as colors from '../../../constants/colors';
import { zeroNegativesInclusiveLin2Log, zeroNegativesInclusiveLog2Lin } from './logarithmicAxisUtils';
export const defaultLogarithmicAxisOptions = fromJS({
  type: 'logarithmic',
  lineColor: 'transparent',
  lineWidth: 1,
  gridLineColor: colors.BATTLESHIP_TRANSPARENT,
  gridLineWidth: 1,
  gridLineDashStyle: 'ShortDash',
  tickColor: colors.LINE_COLOR_DARK,
  tickPosition: 'inside',
  tickLength: '5',
  labels: {
    style: {
      color: 'inherit'
    }
  },
  stackLabels: {
    style: {
      color: 'inherit'
    }
  },
  title: {
    text: null,
    style: {
      color: 'inherit'
    }
  },
  reversedStacks: false,
  softMin: 0,
  softMax: 1,
  events: {
    afterInit() {
      // Avoid errors on negative numbers on a log axis
      this.positiveValuesOnly = false;

      // Override the converter functions so that we can fake showing negative
      // numbers and 0 although such log scale values are mathmatically impossible
      // see logarithmicAxisUtils for more details on log2lin & lin2log

      // default method: log2lin = function(num){return Math.log(num)/Math.LN10;}
      this.logarithmic.log2lin = zeroNegativesInclusiveLog2Lin;
      // default method: lin2log = function(num){return Math.pow(10,num);}
      this.logarithmic.lin2log = zeroNegativesInclusiveLin2Log;
    }
  }
});